/*
	Maybe use with APP.getView().showChildView('pagingRegion',Backbone.Radio.channel('views').request('pagination'))
	
	More likely in a child view though...
		this.showChildView('paging', Backbone.Radio.channel('views').request('pagination',{
            collection: this.collection
        })); 	


	OPTIONS - only has collections in it
		options = {
			collection	
		}

*/
Backbone.Radio.channel('views').reply('pagination-by-letter',function(options){
	var pagingView = Marionette.View.extend({
			/* we could just reference options.collections everywhere in here, 
				but this lets us be consistent with other views and use this.collection
			*/
             collection: options.collection
            ,className:"paging-by-letter d-flex font-size1 font-light border-b"
            ,template: function(c){
	            //get all letters we will need for our nav
                var letters = [];
                //do we need to show 0-9 in the list?
                var hasNonLetters = false;
                
                _.each(c.items,function(item){
	                letters.push(item.title_sortable.charAt(0).toUpperCase())
                })
                
                htm = "";
                
                // Add an entry to every letter, skip non-alpha
                _.each(_.uniq(letters), function(l){
	                var code = l.charCodeAt(0);
	                if( (code > 64 && code < 91) ||   	// upper alpha (A-Z)
						(code > 96 && code < 123) ){  	// lower alpha (a-z)
						htm += "<a class='pl2 pr2"+((c.state.l===l)?" current":"")+"' href='/"+c.state.type+"/list/f/l:"+l+"'>"+l+"</a>"	
					}else{
						hasNonLetters=true;
					}
                })
                
                if(hasNonLetters){
	                htm = "<a class='pl2 pr2"+((c.state.l==='nonalpha')?" current":"")+"' href='/"+c.state.type+"/list/f/l:nonalpha'>0-9</a>" + htm;
                }
                
                if(c.state.type==="radio"){
	            	htm = "<a class='pr2"+((c.state.l==='popular')?" current":"")+"' href='/"+c.state.type+"'>Local Only</a>" + htm;    
                }else{
	                htm = "<a class='pr2"+((c.state.l==='popular')?" current":"")+"' href='/"+c.state.type+"'>Popular</a>" + htm;
                }
                
                
                
                
                return _.template(htm)
            }
            ,templateContext: function() {
                return {
                    state: this.collection.state
                }
            }
            ,collectionEvents: {
                'update': 'render'
            }
            /*
            ,events:{
                "click a": function(e){
                    e.preventDefault();
                    console.log('event')
                    //will automagically update the other views this collection is in
                    //this.collection.getPage(+e.currentTarget.dataset.page)
                    //this.collection.byLetter(e.currentTarget.innerHTML)
                    //this.triggerMethod('page:updated',this)
                    
                    //var params = (+e.currentTarget.dataset.page!==1)?("page:"+e.currentTarget.dataset.page):"";
					//Backbone.history.navigate('/'+this.collection.state.type+ ((params)?"/list/f/"+params:""));
                }
            }
            */
        })
	
	
    return new (pagingView)();
});

